import styled from "styled-components";
import theme from "../theme";

const IconButton = styled.a`
  background: none;
  border: none;
  font-size: ${theme.fonts.small.fontSize};
  cursor: pointer;
  display: inline-block;
  padding: 0 ${theme.unit * 0.25}px;
  line-height: 0;

  &:hover {
    opacity: 0.7;
  }
`;

export default IconButton;
